"use strict";

var _defineProperty = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/defineProperty.js");
var _objectWithoutProperties = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/objectWithoutProperties.js");
const _excluded = ["classNames", "errorMessage", "preview", "label", "subLabel", "ariaLabel", "innerRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _eyeClosedInline = _interopRequireDefault(require("../../images/eye-closed.inline.svg"));
var _eyeOpenInline = _interopRequireDefault(require("../../images/eye-open.inline.svg"));
var _label = _interopRequireWildcard(require("./label"));
var _errorMessage = _interopRequireDefault(require("./error-message"));
var _textfieldModule = _interopRequireDefault(require("./textfield.module.scss"));
var _field = require("./field");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
// Password field component
// ========================

class PasswordField extends _react.Component {
  constructor() {
    super(...arguments);
    // eslint-disable-next-line react/sort-comp
    (0, _defineProperty2.default)(this, "fieldId", this.props.id || (0, _field.makeIdString)());
    (0, _defineProperty2.default)(this, "state", {
      value: this.props.value,
      preview: false
    });
    (0, _defineProperty2.default)(this, "onChange", event => {
      this.setState({
        value: event.target.value
      });
      if (this.props.onChange) {
        this.props.onChange(event);
      }
    });
    (0, _defineProperty2.default)(this, "togglePreview", () => {
      this.setState({
        preview: !this.state.preview
      });
    });
  }
  componentDidUpdate(prevProps) {
    if (this.props.value && prevProps.value !== this.props.value) {
      this.setState((_state, props) => ({
        value: props.value
      }));
    }
  }
  getPreviewLabel() {
    return this.state.preview ? 'Hide' : 'Show';
  }
  renderPasswordPreview() {
    const svgProps = {
      className: _textfieldModule.default.showHideIcon
    };
    return this.props.preview && this.state.value ? /*#__PURE__*/_react.default.createElement("div", {
      className: _textfieldModule.default.passwordPreviewWrapper
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: (0, _classnames.default)(_textfieldModule.default.passwordPreview, {
        [_textfieldModule.default.errorBackground]: this.props.errorMessage
      }),
      type: "button",
      "aria-label": "".concat(this.getPreviewLabel(), " Password"),
      onClick: this.togglePreview
    }, this.state.preview ? /*#__PURE__*/_react.default.createElement(_eyeClosedInline.default, svgProps) : /*#__PURE__*/_react.default.createElement(_eyeOpenInline.default, svgProps))) : null;
  }
  render() {
    const _this$props = this.props,
      {
        classNames: inputClassNames,
        errorMessage,
        preview,
        label,
        subLabel,
        ariaLabel,
        innerRef
      } = _this$props,
      fieldProps = _objectWithoutProperties(_this$props, _excluded);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_textfieldModule.default.Textfield, inputClassNames.wrapper)
    }, /*#__PURE__*/_react.default.createElement(_label.default, {
      className: (0, _classnames.default)(inputClassNames.label, {
        [_textfieldModule.default.errorLabel]: errorMessage
      }),
      for: this.fieldId
    }, label), /*#__PURE__*/_react.default.createElement(_label.SubLabel, {
      className: (0, _classnames.default)(inputClassNames.subLabel, {
        [_textfieldModule.default.errorLabel]: errorMessage
      })
    }, subLabel), /*#__PURE__*/_react.default.createElement("div", {
      className: _textfieldModule.default.fieldIconContainer
    }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, fieldProps, {
      ref: innerRef,
      type: preview && this.state.preview ? 'text' : 'password',
      autoComplete: "off",
      id: this.fieldId,
      value: this.state.value,
      className: (0, _classnames.default)(_textfieldModule.default.field, {
        [_textfieldModule.default.fieldInvalid]: errorMessage
      }, inputClassNames.field),
      "aria-label": ariaLabel,
      onChange: this.onChange
    })), this.renderPasswordPreview()), errorMessage && /*#__PURE__*/_react.default.createElement(_errorMessage.default, {
      message: errorMessage,
      className: inputClassNames.errorMessage
    }));
  }
}
exports.default = PasswordField;
PasswordField.propTypes = _objectSpread(_objectSpread({}, _field.textfieldPropTypes), {}, {
  preview: _propTypes.default.bool,
  classNames: _propTypes.default.object
});
PasswordField.defaultProps = {
  classNames: {}
};